"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserAgent = exports.getVersion = void 0;
function getVersion() {
    return "canary";
}
exports.getVersion = getVersion;
function getUserAgent() {
    return `next-collect : github.com/jitsucom/next-collect : version=${getVersion()} bot=true`;
}
exports.getUserAgent = getUserAgent;
